import React, { useState } from "react";
import {
  Text,
  Stack,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  Button,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { newPass } from "../services/forgotPass";
import { GoBackButton } from "./GoBackButton";

export const NewPassword = ({ setSignUpp, email, resetToken }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!password || !confirmPassword) return;
    setLoading(true);
    newPass({ email, resetToken, password, confirmPassword }, setSignUpp, setLoading);
  };

  return (
    <Stack>
      <GoBackButton onClick={() => setSignUpp("authlogin")} />
      <Text
        color={"primary.500"}
        fontSize="40px"
        fontWeight={"semibold"}
        mb={"-10px"}
      >
        Create New Password
      </Text>
      <Text fontSize={"18px"} fontWeight={500}>
        Create new password
      </Text>
      <FormControl cursor={"pointer"} borderColor="#CFE5E2">
        <FormLabel
          htmlFor="new-password"
          color={"#4D4A4A"}
          fontSize="12px"
          pt={"17px"}
        >
          New Password
        </FormLabel>
        <InputGroup>
          <Input
            id="new-password"
            type={showNew ? "text" : "password"}
            bg={"#F9FEFF"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <InputRightElement>
            <IconButton
              variant="ghost"
              size="sm"
              aria-label={showNew ? "Hide password" : "Show password"}
              icon={showNew ? <ViewOffIcon /> : <ViewIcon />}
              onClick={() => setShowNew((v) => !v)}
            />
          </InputRightElement>
        </InputGroup>

        <FormLabel
          htmlFor="confirm-password"
          color={"#4D4A4A"}
          fontSize="12px"
          pt={"17px"}
        >
          Confirm Password
        </FormLabel>
        <InputGroup>
          <Input
            id="confirm-password"
            type={showConfirm ? "text" : "password"}
            bg={"#F9FEFF"}
            mb="15px"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <InputRightElement>
            <IconButton
              variant="ghost"
              size="sm"
              aria-label={showConfirm ? "Hide password" : "Show password"}
              icon={showConfirm ? <ViewOffIcon /> : <ViewIcon />}
              onClick={() => setShowConfirm((v) => !v)}
            />
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <Button
        bg={"primary.500"}
        size={"md"}
        color="#FFFFFF"
        w="100%"
        fontWeight={400}
        fontSize={"13px"}
        isLoading={loading}
        _hover={{ bg: "primary.600" }}
        onClick={handleSubmit}
      >
        Save Password
      </Button>
    </Stack>
  );
};
